<template>
  <div v-if="false"/>
</template>

<script>
export default {
  created () {
    this.fetchCodelists()

    // Remove employees list filters when User opens application
    // This is done to avoid possible bugs due to filters resetting
    // It also avoids bug which would occur if user received URL to details page and went back to list page (assuming he had filters stored in local storage from previous uses)
    // It also avoids possible bugs due to logging in with another user account
    sessionStorage.removeItem("employeesList")
  },
  methods: {
    fetchCodelists () {
      const codelists = [
        "document-categories",
        "document-types",
        "countries",
        "languages",
        "companies",
        "employee-statuses",
        "document-template-views",
        "payment-types",
        "profiles",
        "profile-standards",
        "marital-statuses",
        "education",
        "drivers-licences",
        "cost-classes",
        "family-relations",
        "car-types",
        "vat-statuses",
        "company-statuses",
        "company-activity",
        "company-business-units",
        "company-contact-position",
        "rental-companies"
      ]
      this.$api.CodeLists.get({ params: codelists }).then(res => {
        if (res.status === 200) this.$emit("ready")
      })
    }
  }
}
</script>
